import { reactive } from 'vue'
import type { Comment, CommentEntityType } from '@/types'

export interface CommentsState {
  comments: Comment[]
  isLoading: boolean
  error: string | null
  currentEntityType: CommentEntityType | null
  currentEntityId: string | null
}

export const getInitialState = (): CommentsState => ({
  comments: [],
  isLoading: false,
  error: null,
  currentEntityType: null,
  currentEntityId: null,
})

export const createState = (): CommentsState => {
  return reactive<CommentsState>(getInitialState())
}

export const resetState = (state: CommentsState): void => {
  const initial = getInitialState()
  state.comments = initial.comments
  state.isLoading = initial.isLoading
  state.error = initial.error
  state.currentEntityType = initial.currentEntityType
  state.currentEntityId = initial.currentEntityId
}
